// Support-portal (Clinic Success Admin / respective Clinic Success Manager) APIs for
// viewing and managing the Clinic Assistants attached to a clinic location.
// Backend: /api/secure/cc/clinic-assistants/* (see ClinicAssistantAdminController).
//
// CSM "respective" scoping is enforced server-side (enforceClinicSuccessManagerScope):
// a Clinic Success Manager only ever sees / edits brands+locations they are approved for.
//
// Role note (mirrored in the UI): permissions / support-roles / default are editable by
// ADMIN, CLINIC_SUCCESS_ADMIN and CLINIC_SUCCESS_MANAGER; enable/disable + approval are
// ADMIN / CLINIC_SUCCESS_ADMIN only.
import {
  getSPDataWithParams,
  patchSPDataWithParams,
  postSPDataWithoutParams,
} from './services'

const BASE = '/api/secure/cc/clinic-assistants'

// GET enriched roster for a clinic location:
// { rows: [{ assignment, user, profile, managers }], availableManagers, clinicBrandId }
export async function getClinicAssistantsDetailedForClinic(clinicId) {
  return getSPDataWithParams(`${BASE}/assignment/detailed`, { clinicId })
}

// PATCH permission flags / voice-call permissions. Send only changed fields alongside
// assignmentId — the backend treats unspecified Booleans as "leave unchanged".
export async function updateAssignmentPermissions(payload) {
  return patchSPDataWithParams(`${BASE}/assignment/permissions`, payload)
}

// PATCH the full supportRoles[] array for an assignment.
export async function updateAssignmentSupportRoles(payload) {
  return patchSPDataWithParams(`${BASE}/assignment/support-roles`, payload)
}

// PATCH default-for-clinic-location flag (only one assignment per location may be default).
export async function updateAssignmentDefault(payload) {
  return patchSPDataWithParams(`${BASE}/assignment/default`, payload)
}

// PATCH enabled flag (ADMIN / CLINIC_SUCCESS_ADMIN only).
export async function updateAssignmentEnabled(payload) {
  return patchSPDataWithParams(`${BASE}/assignment/enabled`, payload)
}

// POST approve / reject an assignment (ADMIN / CLINIC_SUCCESS_ADMIN only).
export async function approveAssignment(payload) {
  return postSPDataWithoutParams(`${BASE}/assignment/approval`, payload)
}
